import React, { Component } from 'react';
import { EUIPage } from '../EUI/EUIPage';

export class Configuration extends Component {

    render = () => <EUIPage
        baseUrl="/Configuration"
        onglets={[
            { url: "/ListeTaches", titre: "Projets" },
            { url: "/ListeTickets/Normal/Tous", titre: "Tickets" },
            { url: "/ListeTicketsByEtat/Etat/Ouvert", titre: "Tickets ouverts" },
            { url: "/ListeTicketsByAAffecter/AAffecter/true", titre: "Tickets à affecter" },
            { url: "/ListeComptes", titre: "Comptes utilisateur" },
            { url: "/ListeNews", titre: "News" },
            { url: "/ListeJournalisations", titre: "Journaux" },
            { url: "/ListeDroits", titre: "Droits" },
            { url: "/GestionAPIs", titre: "Gestion des APIs" },
            { url: "/GestionContratsElectroniques", titre: "Gestion des Signatures" },
            { url: "/GestionPublipostage", titre: "Publipostage" },
        ]}
    />;

}